<template>
  <vSelect class="st-select" placeholder="Select place" label="constituency" :options="newOptions" @input="oninput">
  </vSelect>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import _uniqBy from 'lodash/uniqBy'

export default {
  props: ['options'],
  components: {
    vSelect
  },
  data () {
    return {
      newOptions: []
    }
  },
  watch: {
    'options': function (newVal) {
      this.newOptions = _uniqBy(newVal, 'constituency')
    }
  },
  methods: {
    oninput (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
.st-select.v-select {
  .vs__dropdown-toggle {
    border-radius: 20px;
    border: 2px solid rgba(60, 60, 60, 0.26);
    position: relative;

    .vs__selected-options {
      .vs__selected,
      input {
        padding: 6px 20px;
        font-family: $font-CuratorRegular;
        font-size: 15px;
        color: #666666;
      }
    }
  } // dropdown-toggle

  li {
    padding: 10px 17px;
    font-family: $font-CuratorRegular;
    font-size: 15px;
    line-height: 1.1;
    color: #333333;
  }
}
</style>
